if (!customElements.get("sticky-atc")) {
    customElements.define(
      "sticky-atc",
      class StickyATC extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            stickyContainer: document.querySelector(".sticky-atc"),
            originalButton: document.querySelector('[id^="ProductSubmitButton-"]'),
            mainForm: document.querySelector("product-form"),
            mainVariantRadios: document.querySelector("variant-radios"),
            stickyMobileRadios: document.querySelector("#variant-radios-mobile-" + this.dataset.section),
            stickyDesktopRadios: document.querySelector("#variant-radios-desktop-" + this.dataset.section),
            stickyButton: document.querySelector(".sticky-atc-button"),
            bundleElement: document.querySelector(".revy-bundle-wrapper-inner")
          };
  
          if (this.elements.stickyContainer && this.elements.originalButton) {
            this.init();
          }
        }
  
        init() {
          this.checkButtonVisibility();
          
          let ticking = false;
          window.addEventListener("scroll", () => {
            if (!ticking) {
              window.requestAnimationFrame(() => {
                this.checkButtonVisibility();
                ticking = false;
              });
              ticking = true;
            }
          });
  
          this.setupVariantListeners();
          this.setupFormListener();
          this.abbreviateSizes();
        }

        abbreviateSizes() {
          const sizeMap = {
            'Extra Extra Small': 'XXS',
            'Extra Small': 'XS', 
            'Small': 'S',
            'Medium': 'M',
            'Large': 'L',
            'Extra Large': 'XL',
            'Extra Extra Large': 'XXL'
          };

          // Target only sticky ATC variant labels, and check if this is a size option
          const stickyFieldsets = this.querySelectorAll('.sticky-atc variant-radios fieldset');
          
          stickyFieldsets.forEach(fieldset => {
            const legend = fieldset.querySelector('.form__label');
            const isSize = legend && legend.textContent.toLowerCase().includes('size');
            
            if (isSize) {
              const labels = fieldset.querySelectorAll('label');
              labels.forEach(label => {
                const originalText = label.textContent.trim();
                if (sizeMap[originalText]) {
                  label.textContent = sizeMap[originalText];
                  label.setAttribute('data-original-size', originalText);
                  label.setAttribute('title', originalText); // Show full name on hover
                }
              });
            }
          });
        }
  
        setupFormListener() {
          const form = document.querySelector(`form[id="${this.elements.stickyButton.getAttribute('form')}"]`);
          if (form) {
            form.addEventListener('submit', () => {
              this.elements.stickyButton.classList.add('loading');
              setTimeout(() => {
                this.elements.stickyButton.classList.remove('loading');
              }, 1000);
            });
          }
        }
  
        setupVariantListeners() {
          const { mainVariantRadios, stickyMobileRadios, stickyDesktopRadios } = this.elements;
          
          const handleChange = (event) => {
            if (event.target.type === 'radio') {
              this.syncVariantSelection(event.target);
            }
          };
  
          [mainVariantRadios, stickyMobileRadios, stickyDesktopRadios]
            .filter(Boolean)
            .forEach(container => {
              container.addEventListener('change', handleChange);
            });
        }
  
        syncVariantSelection(changedRadio) {
          const { mainVariantRadios, stickyMobileRadios, stickyDesktopRadios } = this.elements;
          const name = changedRadio.name;
          const value = changedRadio.value;
  
          [mainVariantRadios, stickyMobileRadios, stickyDesktopRadios]
            .filter(Boolean)
            .forEach(container => {
              const radio = container.querySelector(
                `input[type="radio"][name="${name}"][value="${value}"]`
              );
              if (radio) {
                radio.checked = true;
              }
            });
  
          if (!changedRadio.closest('variant-radios')) {
            const mainRadio = mainVariantRadios?.querySelector(
              `input[type="radio"][name="${name}"][value="${value}"]`
            );
            if (mainRadio) {
              mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
  
        checkButtonVisibility() {
          const { originalButton, stickyContainer, bundleElement } = this.elements;
          const buttonRect = originalButton.getBoundingClientRect();
          
          let shouldShow = buttonRect.bottom < 0;
          
          if (bundleElement) {
            const bundleRect = bundleElement.getBoundingClientRect();
            const bundleVisible = bundleRect.top < window.innerHeight && bundleRect.bottom > 0;
            shouldShow = shouldShow && !bundleVisible;
          }
          
          stickyContainer.classList.toggle("show", shouldShow);
          document.body.classList.toggle('sticky-atc-visible', shouldShow);
        }
      }
    );
  }